import ReactJson from "react-json-view";
import { useInfiniteQuery, useMutation } from "@tanstack/react-query";
import { useInView } from "react-intersection-observer";
import { fetchAllJobs, fetchAllJobsByRange, fetchAllTickets, fetchLogsByBenefitPlanHccId, fetchupdateToKanbanBoard } from "../../utils/apiUtils";
import SharedTable from "../benefitPlan/SharedTable";
import { useCallback, useEffect, useState } from "react";
import debounce from "lodash.debounce";
import { queryClient } from "../../App";
import DatePicker from "react-datepicker";
import { AsyncPaginate } from "react-select-async-paginate";
import { loadBenefitPlans, loadUsers } from "../../utils/optionLoaderUtils";
import { customStyles } from "../../utils/styleUtils";

const BenefitPlanAudit = () => {
    const [searchValue, setSearchValue] = useState();
    const [decouncedSearchValue, setDecouncedSearchValue] = useState();
    const [lastUpdatedAt, setLastUpdatedAt] = useState()
    const [selectedBenefitPlan, setSelectedBenefitPlan] = useState(null)

    const [selectedUser, setSelectedUser] = useState(null)
    const [selectedDate, setSelectedDate] = useState();

    const { ref, inView } = useInView();

    const queryKey = ['audit', selectedBenefitPlan, selectedUser, decouncedSearchValue];

    const {
        data,
        refetch,
        fetchNextPage,
        fetchPreviousPage,
        isLoading, //first time only
        isFetching,
        isSuccess,
        hasNextPage,
        isFetched,
        hasPreviousPage,
        isFetchingNextPage,
        isFetchingPreviousPage,
        isError,
        status,
        error
    } = useInfiniteQuery({
        retry: false,
        refetchOnWindowFocus: true,
        queryKey,
        queryFn: ({ pageParam }) => {
            let params = { lastEvaluatedKey: pageParam };

            if (decouncedSearchValue) {
                params.skPrefix = decouncedSearchValue
            }

            if (selectedBenefitPlan) {
                params.pk = selectedBenefitPlan.value
            } else if (selectedUser) {
                params.pk = selectedUser.value
            }
            // if (!selectedDate) {
            //     return fetchAllJobs(params)
            // }

            // if (selectedDate) {
            //     params.createdAt = selectedDate.toISOString()
            // }



            return fetchLogsByBenefitPlanHccId(params)
        },
        select: (data) => {
            return {
                pages: data.pages.map((page) => page.Items?.map(item => {
                    if (item.requestBody) {
                        try {
                            item.requestBodyParsed = JSON.parse(item.requestBody)
                        } catch (err) {
                            console.log(err)
                        }

                    }
                    return item
                })).flatMap((x) => x),
                pageParams: data.pageParams,
            };
            // return { ...data.hits, timestamp: Date.now() }
        },
        getNextPageParam: (lastPage, allPages) => {
            return lastPage.LastEvaluatedKey ? encodeURIComponent(JSON.stringify(lastPage.LastEvaluatedKey)) : null
        },

        staleTime: 0,//,Infinity,
        enabled: !!(selectedBenefitPlan || selectedUser) //&& !!showChat
    })

    useEffect(() => {
        if (inView) {
            fetchNextPage();
        }
    }, [inView]);

    const debouncedChangeHandler = useCallback(
        debounce((event) => {
            setDecouncedSearchValue(event.target.value?.trim());
        }, 500),
        []
    );

    // const resutls = data?.pages.flat()

    const columns = ['pk', 'sk', 'action', 'requestBodyParsed.asOfDate', 'benefitPlanHccId', 'lsi1'

    ];

    const results = data?.pages.flat()
    return (
        <div className="container">
            <p className="title">Benefit Plan Audit</p>
            <p className="sub-title">Change history</p>

            <p className="sub-title">Search by user or benefit hcc ID </p>
            {/* {lastUpdatedAt} */}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '1rem 1rem 1rem 0rem', }}>
                <div style={{ display: 'flex', gap: '1rem', alignItems: 'center', width: '100%', flexWrap: 'wrap', }}>

                    {!selectedUser && <AsyncPaginate
                        placeholder={"Select a benefit plan"}
                        className="react-select-container large-input"
                        classNamePrefix={"react-select"}
                        debounceTimeout={300}
                        value={selectedBenefitPlan}
                        loadOptions={loadBenefitPlans}
                        onChange={(val) => { setSelectedBenefitPlan(val); setSelectedUser(null) }}
                        styles={customStyles}
                        isClearable
                    />}

                    {!selectedUser && !selectedBenefitPlan && <p>OR</p>}

                    {!selectedBenefitPlan && <AsyncPaginate
                        placeholder={"Select a User"}
                        className="react-select-container large-input"
                        classNamePrefix={"react-select"}
                        debounceTimeout={300}
                        value={selectedUser}
                        loadOptions={loadUsers}
                        onChange={(val) => { setSelectedUser(val); setSelectedBenefitPlan(null) }}
                        styles={customStyles}
                        isClearable
                    />}

                    {/* <DatePicker
                        className="date-picker"
                        placeholderText="Created at date "
                        inline={false}
                        dateFormat={'yyyy-MM-dd'}
                        selected={selectedDate}
                        onChange={(date) => setSelectedDate(date)}
                        maxDate={new Date()}
                    /> */}
                    {/* 
                    {JSON.stringify(selectedDate)} */}

                    {(selectedBenefitPlan || selectedUser) && <input
                        style={{ fontSize: "1rem", minWidth: "250px", padding: "1rem", borderRadius: ".4rem", border: "1px solid var(--lighterGrey)", outline: "none" }}
                        type="text"
                        id={"sk-prefix"}
                        placeholder="sk prefix ..."
                        // list="items"
                        autoComplete="off"
                        // onFocus={() => setCurrentPage(0)}
                        onChange={(e) => {

                            setSearchValue(e.target.value);
                            debouncedChangeHandler(e);
                        }}
                        value={searchValue}
                    />}

                </div>
            </div>

            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "0rem 1rem 1rem 0rem" }}>
                <p
                    style={{ cursor: "pointer", color: "var(--red)" }}
                    onClick={() => {

                        setSelectedUser(null)
                        setSelectedBenefitPlan(null)
                        setDecouncedSearchValue("");
                        setSearchValue("");
                    }}
                >
                    Clear filters
                </p>

            </div>


            {status === "loading" ? (
                <p>Loading...</p>
            ) : status === "error" ? (
                <span className='danger'>Error: {error.message}</span>
            ) : isSuccess ? (
                <>
                    <SharedTable
                        type={"benefit-plan-audit"}
                        columns={columns}
                        items={results}
                        activeDraftId={null}
                        hasNextPage={hasNextPage}
                        isFetchingNextPage={isFetchingNextPage}
                        fetchNextPage={fetchNextPage}
                        isFetching={isFetching}
                        isLoading={isLoading}
                        // onDetailHandler={onDetailHandler}
                        ref={ref}
                    />
                </>
            ) : <></>}


        </div>
    )
}


export default BenefitPlanAudit